import React from 'react'

export default function SmallArrowRightIcon({ ...props }) {
    return (
        <svg {...props} viewBox="0 0 16 17" fill="none">
        <path d="M6.5 11.5L9.5 8.5L6.5 5.5" stroke="currentcolor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        
    )
}